import type { ReactElement } from 'react';
import { SvgUpRight } from '@/components/icons-eataly';
import { cn } from '@/lib/utils';

export type ExternalLinkIconProps = {
    className?: string;
};

/** Decorative external-link indicator; hide from assistive tech (use aria-label / sr-only on the link). */
export function ExternalLinkIcon({ className }: ExternalLinkIconProps): ReactElement {
    return (
        <span aria-hidden className={cn('inline-flex shrink-0', className)}>
            <SvgUpRight className="size-4" />
        </span>
    );
}
